import React from 'react';

const BackgroundShapes = () => {
  return (
    <div className="background-shapes">
      <div 
        className="shape shape-circle-1"
        style={{ backgroundImage: 'url(/fondo1.jpg)' }}
      ></div>
      <div 
        className="shape shape-rectangle"
        style={{ backgroundImage: 'url(/fondo2.PNG)' }}
      ></div>
      <div 
        className="shape shape-circle-2"
        style={{ backgroundImage: 'url(/fondo3.jpg)' }}
      ></div>
      <div 
        className="shape shape-rectangle-2"
        style={{ backgroundImage: 'url(/fondo4.jpg)' }}
      ></div>
      <div 
        className="shape shape-rectangle-3"
        style={{ backgroundImage: 'url(/fondo5.webp)' }}
      ></div>
    </div>
  );
};

export default BackgroundShapes;